var _style, _g, _g2, _g3, _g4, _g5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg03LocationSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#EBEBEB;}\r\n\t.st1{fill:#E0E0E0;}\r\n\t.st2{fill:#263238;}\r\n\t.st3{fill:#455A64;}\r\n\t.st4{fill:#F5F5F5;}\r\n\t.st5{fill:#FFFFFF;}\r\n\t.st6{fill:#042b62;}\r\n\t.st7{fill:#FFBE9D;}\r\n\t.st8{fill:#EB996E;}\r\n\t.st9{opacity:0.3;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 432.6,
    y: 114.4,
    className: "st0",
    width: 48.6,
    height: 12.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M229.1,412.4c0-15.5-12.5-28.1-28.1-28.1c-15.5,0-28.1,12.5-28.1,28.1c0,5,1.3,9.9,3.9,14.3l0,0l0.1,0.1 c1.1,1.8,2.4,3.1,3.8,5l16.3,21.6c1.7,2.2,4.9,2.7,7.1,1c0.4-0.3,0.7-0.6,1-1l16-21.3c1.5-1.7,2.8-3.5,4.1-5.4l0.1-0.1l0,0 C227.8,422.3,229.1,417.4,229.1,412.4z M201,424.6c-6.8,0-12.4-5.5-12.4-12.4s5.5-12.4,12.4-12.4s12.4,5.5,12.4,12.4c0,0,0,0,0,0 C213.4,419.1,207.8,424.6,201,424.6C201,424.6,201,424.6,201,424.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.2,
    y: 53.2,
    className: "st0",
    width: 48.7,
    height: 12.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M103.6,79.7c0-0.1,0-0.2,0-0.2v-0.7c0-0.6,0-1.4,0-2.5c0-2.2,0-5.4-0.1-9.4l0.2,0.2L55,67.1l0.2-0.2l0,0v3.3 c0,1.1,0,2.2,0,3.2v6.3L55,79.4l34.7,0.1l10.2,0.1h2.8h0.7L103.6,79.7c0-0.1-0.1-0.1-0.2-0.1h-0.7H100l-10.2,0.1L55,79.9h-0.2v-0.2 c0-2.1,0-4.2,0-6.3v-6.5l0,0l0.2-0.2l48.7,0.1h0.2v0.2c0,4.1-0.1,7.3-0.1,9.5c0,1.1,0,1.9,0,2.5c0,0.3,0,0.5,0,0.6 S103.7,79.7,103.6,79.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 427.2,
    y: 393.3,
    className: "st0",
    width: 48.6,
    height: 12.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M454.7,419.7c0-0.1,0-0.2,0-0.2c0-0.2,0-0.4,0-0.7c0-0.6,0-1.5,0-2.5c0-2.2,0-5.4-0.1-9.5l0.1,0.1l-48.6,0.1 c0.1-0.1-0.2,0.2,0.2-0.2l0,0v12.9l-0.2-0.2l34.7,0.1l10.2,0.1h2.8h0.7L454.7,419.7l-0.2-0.1h-0.7h-2.7l-10.2,0.1L406,420h-0.2 v-13.1l0,0c0.5-0.5,0.1-0.1,0.2-0.2l48.6,0.1h0.1v0.1c0,4.1-0.1,7.3-0.1,9.5c0,1.1,0,1.9,0,2.5c0,0.3,0,0.5,0,0.6 C454.7,419.6,454.7,419.7,454.7,419.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M347,59.2c0-0.1,0-0.2,0-0.2v-0.7c0-0.6,0-1.5,0-2.5c0-2.2,0-5.4-0.1-9.5l0.1,0.2l-48.6,0.1l0.2-0.2l0,0v6.5 c0,2.1,0,4.3,0,6.3l-0.2-0.2l34.7,0.1l10.2,0.1h2.8h0.7L347,59.2c0-0.1-0.1-0.1-0.2-0.1h-0.7h-2.7l-10.2,0.1l-34.8,0.1h-0.2v-0.2 c0-2.1,0-4.2,0-6.3v-6.4l0,0l0.2-0.2l48.6,0.1h0.1v0.2c0,4.1-0.1,7.3-0.1,9.5c0,1.1,0,1.9,0,2.5v0.6C347,59.2,347,59.3,347,59.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M353.6,46.4c0-0.1,0-0.2,0-0.2v-0.7c0-0.6,0-1.5,0-2.6c0-2.3-0.1-5.5-0.1-9.4l0.2,0.2l-29.2,0.1 c-0.2,0.2,0.3-0.3,0.2-0.2l0,0v6.6c0,2.2,0,4.2,0,6.2l-0.2-0.2l20.9,0.1l6.1,0.1h1.6L353.6,46.4c-0.1-0.1-0.3-0.1-0.4-0.1h-1.6 l-6,0.1l-21.1,0.1h-0.2v-0.2c0-2,0-4.1,0-6.2v-6.5l0,0l0.2-0.2l29.2,0.1h0.2v0.2c0,4-0.1,7.2-0.1,9.5c0,1.1,0,1.9,0,2.5 S353.6,46.4,353.6,46.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M72.4,425.4c0,0,0-0.1,0-0.2v-0.7c0-0.6,0-1.5,0-2.5c0-2.2,0-5.4-0.1-9.4l0.2,0.1l-48.7,0.1l0.2-0.2l0,0v6.5 c0,2.1,0,4.3,0,6.3l-0.2-0.2l34.7,0.1l10.2,0.1h2.8h0.7L72.4,425.4l-0.1-0.1h-0.7h-2.7l-10.2,0.1l-34.8,0.1h-0.2v-0.2 c0-2.1,0-4.2,0-6.3v-6.5l0,0l0.2-0.2l48.7,0.1h0.2v0.1c0,4.1-0.1,7.3-0.1,9.5c0,1.1,0,1.9,0,2.5v0.6 C72.6,425.2,72.5,425.3,72.4,425.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M79,412.5c0-0.1,0-0.2,0-0.2c0-0.2,0-0.4,0-0.7c0-0.6,0-1.5,0-2.6c0-2.3-0.1-5.5-0.1-9.4l0.2,0.2l-29.2,0.1 l0.2-0.2l0,0v6.6c0,2.1,0,4.2,0,6.2l-0.2-0.2l20.9,0.1l6.1,0.1h1.6L79,412.5c-0.1-0.1-0.3-0.1-0.4-0.1H77l-6,0.1l-21.1,0.1h-0.2 v-0.2c0-2,0-4.1,0-6.2v-6.6l0,0l0.2-0.2l29.2,0.1h0.2v0.2c0,4-0.1,7.2-0.1,9.5c0,1.1,0,1.9,0,2.5S79.1,412.5,79,412.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M49.6,85h386.9c7.1,0,12.8,5.7,12.8,12.8v261.8c0,7.1-5.7,12.8-12.8,12.8H49.6c-7.1,0-12.8-5.7-12.8-12.8V97.8 C36.8,90.7,42.6,85,49.6,85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M449.4,97.8l-0.1-0.9c0-0.4-0.1-0.7-0.1-1.1c-0.1-0.5-0.2-1-0.3-1.5c-1-3.4-3.3-6.2-6.4-7.8 c-1.1-0.6-2.2-1-3.4-1.2c-1.3-0.2-2.7-0.3-4-0.2h-9.3h-23.2l-147.6,0.1h-102H51.2c-1.3,0-2.5,0-3.8,0.2c-1.2,0.2-2.4,0.6-3.5,1.2 c-2.3,1.2-4.1,3-5.3,5.2c-0.6,1.1-1,2.3-1.3,3.6c-0.2,1.3-0.3,2.5-0.2,3.8v23.5c0,10.6,0,21.2,0,32v66c0,44.9,0,91.3,0,138.8 c0,6,4.3,11.2,10.2,12.4c1.4,0.2,2.9,0.3,4.4,0.2h116.7h129.3h117H435c1.1,0,2.2,0,3.3-0.1c5.5-0.8,9.8-5,10.7-10.5 c0.1-1.1,0.2-2.1,0.1-3.2c0-1.1,0-2.1,0-3.2v-6.4c0-17,0-33.3,0-48.9c0-62.3,0.1-112.8,0.1-147.6c0-17.4,0-31,0-40.1 c0-4.6,0-8.1,0-10.4S449.3,97.8,449.4,97.8c-0.1,0-0.1,1.2-0.1,3.6s0,5.9,0,10.4c0,9.2,0,22.7,0,40.1c0,34.9,0.1,85.3,0.1,147.6 c0,15.6,0,31.9,0,48.9c0,2.1,0,4.3,0,6.4v3.2c0,1.1,0,2.2-0.1,3.3c-0.6,4.5-3.6,8.4-7.8,10.2c-1,0.4-2.1,0.7-3.2,0.9 c-1.1,0.1-2.2,0.2-3.4,0.2h-20.1h-117H168.4H51.7c-1.5,0.1-3,0-4.5-0.2c-6.2-1.2-10.7-6.6-10.7-12.9c0-47.6,0-94,0-138.8 c0-22.4,0-44.4,0-66V99.2c0-1.3,0-2.6,0.3-3.9c0.3-1.3,0.7-2.5,1.3-3.7c1.3-2.3,3.2-4.2,5.5-5.4c1.2-0.6,2.4-1,3.7-1.2 c1.3-0.2,2.6-0.3,3.8-0.2h44.9h56.8h102l147.6,0.1h23.2h9.3c1.3,0,2.7,0,4,0.3c1.2,0.2,2.4,0.7,3.4,1.2c3.1,1.6,5.5,4.5,6.4,7.9 c0.1,0.5,0.3,1,0.3,1.5c0.1,0.4,0.1,0.7,0.1,1.1C449.4,97.5,449.4,97.8,449.4,97.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M428.6,217.7c6.1,0,11,4.9,11,11s-4.9,11-11,11s-11-4.9-11-11S422.5,217.7,428.6,217.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M58.6,199.3V258c0,2.3-1.8,4.1-4.1,4.1c0,0,0,0,0,0l0,0c-2.3,0-4.1-1.8-4.1-4.1l0,0v-58.7 c0-2.3,1.8-4.1,4.1-4.1h0l0,0C56.8,195.2,58.6,197,58.6,199.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.2,
    y: 94.3,
    className: "st0",
    width: 344.5,
    height: 269.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "288.4,288.7 315,335.7 380.5,334.7 376.8,283.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "201.8,130.2 192.2,204.4 212,209.1 250.9,205.3 243.8,124.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "141.4,282.1 95.5,282.1 95.5,226.8 145.4,227.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M330.5,283.8c0-1.6,8.1-56.5,8.1-56.5s31.7-8.7,31.8-7.4s6.3,62.5,6.3,62.5L330.5,283.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M100.8,143.1c0.1,1.3,21.9,45.3,21.9,45.3l25.3-6.7v-50.5l-26.1-0.6L100.8,143.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.3,
    y: 234.7,
    className: "st1",
    width: 35,
    height: 16.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "255.4,256.7 220.2,258.5 218.4,291.9 258.6,288.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "396.5,194.7 391.6,126.8 410.7,126.8 410.8,193.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "318.3,115.7 326.3,200.3 368,196.6 360.7,124.4 327.7,115.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "126.7,130.8 66.5,129.9 66.5,125.9 123.4,126.8 130,94.3 133.9,95.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "95.2,196.2 66.1,130.7 67,130.3 95.8,195 147.9,181.2 148.1,182.1  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.5,
    y: 226.3,
    className: "st5",
    width: 78.9,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 195.6,
    className: "st5",
    width: 1,
    height: 86.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.5,
    y: 281.6,
    className: "st5",
    width: 75.2,
    height: 1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "137.8,360.3 66.2,344.5 67.1,340.6 134.2,355.4 145.7,195.3 147.4,128.6 150.1,94.6 154.1,94.9  151.4,128.9 149.7,195.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "149.2,133.3 124.9,130.8 125.3,126.8 146.8,129 150.4,121.4 182.5,129.2 326.8,112.7 377,125.8  410.6,124.8 410.7,128.8 376.6,129.8 326.5,116.8 182.2,133.2 152.6,126.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "317,286.9 313,286.4 324.3,200.3 315.6,115.8 315.6,94.3 319.6,94.3 319.6,115.7 328.3,200.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "139.7,298.7 139.5,294.7 375.4,280.4 407.5,215 411.1,216.8 377.9,284.2 376.8,284.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "257.8,291.1 242.8,124.3 241.9,94.8 243.9,94.7 244.8,124.2 259.8,291  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "226.2,362.6 208.7,291.4 208.7,210.8 189.1,205.9 197.6,129.4 196.8,94.3 200.8,94.2 201.6,129.6  201.6,129.8 193.5,202.9 212.7,207.7 212.7,290.9 230.1,361.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.4,
    y: 226.8,
    className: "st5",
    width: 65.3,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169,
    y: 177.6,
    transform: "matrix(0.2016 -0.9795 0.9795 0.2016 -60.476 325.5843)",
    className: "st5",
    width: 1,
    height: 44.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "210.6,260.4 195.1,257 195.1,227.3 196.1,227.3 196.1,256.1 210.9,259.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "186.4,362.5 177.7,334.5 137.8,334.5 137.8,330.5 180.6,330.5 190.2,361.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "314.7,336.2 287.9,289 288.8,288.5 315.3,335.2 410.5,333.8 410.6,334.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.6,
    y: 335.7,
    className: "st5",
    width: 1,
    height: 27
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "380,334.8 376.3,283.8 357.2,94.3 358.2,94.2 377.3,283.7 381,334.7  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.4,
    y: 200.8,
    transform: "matrix(0.9969 -7.915506e-02 7.915506e-02 0.9969 -14.9566 25.2292)",
    className: "st5",
    width: 200.7,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.6,
    y: 128.4,
    transform: "matrix(0.996 -8.941581e-02 8.941581e-02 0.996 -12.8725 35.9266)",
    className: "st5",
    width: 2,
    height: 66.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.2,
    y: 169.2,
    transform: "matrix(0.9707 -0.2402 0.2402 0.9707 -29.6408 96.3341)",
    className: "st5",
    width: 30.2,
    height: 1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "382,169 376.8,139.6 362.1,138 362.2,137 377.6,138.6 383,168.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.4,
    y: 120.7,
    transform: "matrix(0.9963 -8.541693e-02 8.541693e-02 0.9963 -12.7417 24.9679)",
    className: "st5",
    width: 2,
    height: 81.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 169,
    transform: "matrix(0.9766 -0.2149 0.2149 0.9766 -29.3143 69.3266)",
    className: "st5",
    width: 36.3,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299,
    y: 348.8,
    transform: "matrix(0.1279 -0.9918 0.9918 0.1279 -73.7851 615.6929)",
    className: "st5",
    width: 28.5,
    height: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "149.4,229 145.4,291 207.5,288 207.5,263.7 191.2,260.1 191.2,231.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M132.3,244.1c0-7.8-6.3-14.1-14.1-14.1c-7.8,0-14.1,6.3-14.1,14.1c0,2.5,0.7,5,1.9,7.1l0,0v0.1 c0.5,0.9,1.2,1.6,1.9,2.5l8.2,10.8c0.8,1.1,2.4,1.3,3.6,0.5c0.2-0.1,0.4-0.3,0.5-0.5l8-10.7c0.7-0.9,1.4-1.8,2.1-2.7l0,0l0,0 C131.6,249.1,132.3,246.6,132.3,244.1z M118.2,250.2c-3.4,0-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2c3.4,0,6.2,2.8,6.2,6.2 c0,0,0,0,0,0C124.4,247.5,121.6,250.2,118.2,250.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M265,194.5c0-7.8-6.3-14.1-14.1-14.1c-7.8,0-14.1,6.3-14.1,14.1c0,2.5,0.7,5,1.9,7.2l0,0v0.1 c0.5,0.9,1.2,1.6,1.9,2.5l8.2,10.8c0.8,1.1,2.4,1.3,3.6,0.5c0.2-0.1,0.4-0.3,0.5-0.5l8.1-10.6c0.7-0.9,1.4-1.8,2-2.7l0,0l0,0 C264.3,199.5,265,197,265,194.5z M250.9,200.6c-3.4,0-6.2-2.8-6.2-6.2s2.8-6.2,6.2-6.2s6.2,2.8,6.2,6.2l0,0 C257.1,197.8,254.3,200.6,250.9,200.6C250.9,200.6,250.9,200.6,250.9,200.6L250.9,200.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M206.5,316.6c0-5.3-4.3-9.7-9.6-9.7c-5.3,0-9.7,4.3-9.7,9.6c0,1.7,0.5,3.4,1.3,4.9l0,0l0,0 c0.4,0.6,0.8,1.1,1.3,1.7l5.6,7.4c0.6,0.8,1.7,0.9,2.5,0.3c0.1-0.1,0.2-0.2,0.3-0.3l5.5-7.3c0.5-0.6,1-1.2,1.4-1.9l0,0l0,0 C206,320,206.4,318.3,206.5,316.6z M196.8,320.8c-2.4,0-4.3-1.9-4.3-4.2c0-2.4,1.9-4.3,4.2-4.3c2.4,0,4.3,1.9,4.3,4.2c0,0,0,0,0,0 C201,318.9,199.1,320.8,196.8,320.8C196.8,320.8,196.8,320.8,196.8,320.8L196.8,320.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M381.9,141.1c0-5.3-4.4-9.7-9.7-9.6c-4.6,0-8.6,3.3-9.5,7.9c-0.4,2.3,0,4.6,1.2,6.6l0,0l0,0 c0.4,0.6,0.8,1.1,1.3,1.7l5.6,7.4c0.6,0.8,1.7,0.9,2.5,0.3c0.1-0.1,0.2-0.2,0.3-0.3l5.5-7.3c0.5-0.6,1-1.2,1.4-1.9l0,0l0,0 C381.4,144.5,381.9,142.8,381.9,141.1z M372.2,145.3c-2.4,0-4.3-1.9-4.3-4.2c0-2.4,1.9-4.3,4.2-4.3c2.4,0,4.3,1.9,4.3,4.2 c0,0,0,0,0,0C376.4,143.4,374.5,145.3,372.2,145.3L372.2,145.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M176,145.7c0-9.5-7.7-17.1-17.1-17.2c-9.5,0-17.1,7.7-17.2,17.1c0,3.1,0.8,6.1,2.4,8.7l0,0l0.1,0.1 c0.6,1.1,1.5,1.9,2.3,3.1l9.9,13.2c1,1.4,3,1.6,4.3,0.6c0.2-0.2,0.4-0.4,0.6-0.6l9.8-13c0.9-1.1,1.7-2.2,2.5-3.3l0,0l0,0 C175.2,151.7,176,148.8,176,145.7z M158.9,153.2c-4.2,0-7.6-3.4-7.5-7.6c0-4.2,3.4-7.6,7.6-7.6c4.2,0,7.6,3.4,7.5,7.6c0,0,0,0,0,0 C166.4,149.8,163,153.2,158.9,153.2z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M256.8,315.5c0,0,0,35.2-0.4,37.1s-1.5,12.5,1.1,17.4s8.7,14.8,14,16.2s8.3,0,8.3,0s3.3-22.9,2.2-29.5 s-3.5-20.9-3.5-20.9L262,317.2L256.8,315.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "298.2,267.2 313.7,262.5 343.1,260.5 360.9,263.9 341.6,294.8 313.7,292.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M359.7,203.4c0.3,15-5.8,29.5-16.8,39.8c-2.5-7.2-5-14.5-7.5-21.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M303.1,160.1c6.5-3.5,14.2-4,21.4-2.6s13.9,4.7,20.3,8.4c3.6,2.1,7.1,4.3,9.7,7.6c4.7,5.9,9.3,15.6,9.8,23.1 c0.4,6.1-2,21.3-4.5,26.8c-2.4,5.1-13.4,8.9-18.8,10.2L291,175.5C292.8,168.9,297.2,163.4,303.1,160.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M294.5,168l12-2.1c-6.5,15.6-8.3,51.2-12.1,67.7c-4.4-6.4-14.6-25.9-14.1-33.6S280.2,166.6,294.5,168z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M351.2,193.9c-0.4-9-6.7-16.6-15.4-18.8l-27.6-7c-11.9-1.3-19.9,13.4-20.6,25.3c-0.9,13.3-1.4,27.3,0.1,37.2 c3.1,19.9,18.4,22.5,18.4,22.5s0,9.5,0,15.3l24.6,19.5l14.3-22.4l6.2-71.4C351.3,193.8,351.2,194.4,351.2,193.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M293.6,208.4c0,1.4,1.1,2.5,2.5,2.6c1.3,0.1,2.5-0.9,2.6-2.2c0,0,0,0,0-0.1c0-1.4-1.1-2.5-2.5-2.6 C294.9,206,293.7,207,293.6,208.4C293.6,208.4,293.6,208.4,293.6,208.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M290.6,201.2c0.3,0.3,2.3-1.1,5-1.1s4.8,1.4,5.1,1.1c0.1-0.1-0.2-0.8-1-1.4c-1.2-0.8-2.6-1.3-4-1.3 c-1.4,0-2.8,0.4-4,1.3C290.8,200.4,290.5,201,290.6,201.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M317.6,208.4c0,1.4,1,2.5,2.4,2.6c1.3,0.1,2.5-0.9,2.6-2.2c0,0,0,0,0-0.1c0-1.4-1.1-2.5-2.5-2.6 C318.8,206,317.7,207,317.6,208.4C317.6,208.4,317.6,208.4,317.6,208.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M316.7,201.2c0.3,0.3,2.3-1.1,5-1.1s4.8,1.4,5.1,1.1c0.1-0.1-0.2-0.8-1-1.4c-1.2-0.8-2.6-1.3-4-1.3 c-1.4,0-2.8,0.4-4,1.3C316.9,200.4,316.6,201,316.7,201.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M308.1,222.8c0-0.2-1.7-0.5-4.5-0.8c-0.7-0.1-1.4-0.2-1.5-0.7c-0.1-0.7,0.1-1.5,0.5-2.1l2.1-5.3 c2.9-7.6,5-13.9,4.7-14s-2.9,6-5.8,13.6l-2,5.4c-0.4,0.8-0.6,1.8-0.4,2.8c0.2,0.5,0.6,0.9,1.2,1c0.4,0.1,0.8,0.2,1.2,0.2 C306.4,222.9,308.1,222.9,308.1,222.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M332.6,246c0,0-6.5,13.7-26.4,11.8v-4.7C315.5,253.2,324.6,250.8,332.6,246z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M317.6,191.2c0.3,0.8,3,0.4,6.2,0.8s5.8,1.3,6.3,0.6c0.2-0.3-0.3-1-1.3-1.8c-1.4-0.9-3-1.5-4.6-1.6 c-1.6-0.2-3.3,0-4.9,0.6C318.1,190.3,317.5,190.9,317.6,191.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M291.5,192.8c0.5,0.6,2.4,0,4.7,0s4.2,0.4,4.6-0.2c0.2-0.3-0.1-0.9-1-1.5c-2.3-1.5-5.3-1.4-7.5,0.2 C291.6,191.8,291.3,192.5,291.5,192.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M293,175.2c1.2-3,4.5-4.8,7.7-5c3.3,0,6.4,0.9,9.2,2.7c11.9,6.9,18,23.4,29.7,30.5c2.9,1.8,6.6,0.1,9.1,2.5 s4,6,2.7,9.1c1.7-2.1,3.1-4.4,4.1-6.9c1-2.5,0.9-5.3-0.3-7.8c-1-1.8-2.8-3.1-3.3-5.1c-0.4-1.7,0.2-3.5,0.2-5.3 c-0.2-1.8-0.8-3.6-1.8-5.1c-4.6-8.1-10.9-15.5-19-20c-5.3-3.1-11.4-4.6-17.5-4.5c-6.2,0.1-12.1,2.5-16.6,6.6 C294.4,169.3,291.6,171.9,293,175.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M348.5,208.4c0.2-0.6,10.6-4.3,10.7,6.7c0.1,10.7-10.7,8.6-10.7,8.3S348.5,208.4,348.5,208.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M351.8,219.3c0,0,0.2,0.1,0.5,0.3c0.4,0.2,1,0.2,1.4,0c1.1-0.4,2.1-2.2,2.1-4.2c0-0.9-0.2-1.8-0.5-2.7 c-0.2-0.7-0.7-1.2-1.4-1.4c-0.4-0.1-0.9,0.1-1.1,0.5c-0.1,0.3-0.1,0.5-0.1,0.5s-0.2-0.2-0.1-0.6c0.1-0.3,0.2-0.5,0.4-0.7 c0.3-0.2,0.6-0.3,1-0.3c0.9,0.2,1.7,0.8,2,1.6c0.5,0.9,0.7,2,0.7,3c0,2.2-1.1,4.2-2.7,4.7c-0.6,0.2-1.2,0.1-1.7-0.3 C351.8,219.6,351.7,219.3,351.8,219.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M352.8,202.8c-0.2-0.1-0.4-0.2-0.6-0.4c-0.4-0.3-1-0.6-1.8-1.1c-2.1-1.6-4.1-3.3-5.8-5.3 c-2.5-2.9-4.9-6-7.1-9.2c-2.6-3.9-5.6-7.6-8.9-11c-1.7-1.7-3.7-3.2-5.7-4.5c-1.9-1.2-4-2.1-6.2-2.8c-3.7-1.2-7.5-1.7-11.4-1.4 c-2.6,0.2-5.2,0.7-7.6,1.5c-0.9,0.3-1.5,0.6-2,0.7c-0.2,0.1-0.5,0.2-0.7,0.2c0.2-0.1,0.4-0.2,0.7-0.3c0.6-0.3,1.3-0.6,2-0.8 c2.5-0.9,5-1.5,7.7-1.7c3.9-0.3,7.8,0.1,11.5,1.3c2.2,0.7,4.3,1.6,6.3,2.8c2.1,1.3,4,2.9,5.8,4.6c3.3,3.4,6.2,7.2,8.9,11.1 c2.2,3.2,4.5,6.3,7,9.2c1.7,2,3.6,3.8,5.6,5.4c0.7,0.6,1.4,0.9,1.7,1.2C352.4,202.5,352.6,202.7,352.8,202.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M353,221.2c1.1-0.2,2.2,0.6,2.4,1.7c0.2,1-0.4,2.1-1.4,2.4c-1.1,0.4-2.3-0.2-2.7-1.3c-0.4-1,0.1-2.2,1.2-2.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M352.5,221.4c-0.5,0.4-0.8,0.9-1,1.4c-0.2,0.6,0,1.2,0.4,1.7c0.7,0.8,1.9,0.9,2.7,0.2c0.4-0.3,0.6-0.8,0.6-1.3 c0.1-0.6-0.2-1.2-0.6-1.6c-0.5-0.4-1-0.6-1.6-0.6c0,0,0.2-0.1,0.5-0.1c1.2,0,2.2,1,2.2,2.3c0,0,0,0.1,0,0.1 c-0.1,1.3-1.2,2.2-2.5,2.1c-0.6,0-1.2-0.3-1.6-0.8c-0.5-0.6-0.7-1.4-0.4-2.1c0.1-0.5,0.4-0.9,0.8-1.2 C352.3,221.4,352.5,221.3,352.5,221.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M350,205.9c0.2,2.9,0.3,6-1,8.6s-4.8,4.4-7.3,2.9c-2.1-1.2-2.7-3.9-3.1-6.2c-1-6.8-1.5-13.8-2.6-20.6 L350,205.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M295.7,170.1c0,0.1,1-0.2,2.7-0.2c2.4,0,4.8,0.4,7.1,1.3c1.6,0.6,3.1,1.4,4.5,2.3c1.6,1.1,3.1,2.3,4.6,3.5 c3.4,2.9,6.4,6.1,9,9.7c1.4,1.9,2.6,3.9,3.9,5.7c1.2,1.8,2.7,3.4,4.3,4.8c2.8,2.4,5.8,4.4,9.1,6.1c2.8,1.5,5,2.5,6.6,3.2l1.8,0.8 c0.2,0.1,0.4,0.2,0.7,0.2c-0.2-0.1-0.4-0.3-0.6-0.3l-1.8-0.9c-1.6-0.8-3.8-1.8-6.5-3.3c-3.2-1.7-6.2-3.8-8.9-6.1 c-1.6-1.4-3-3-4.2-4.8c-1.3-1.8-2.5-3.8-3.9-5.7c-2.6-3.6-5.7-6.9-9.1-9.8c-1.5-1.3-3-2.4-4.7-3.5c-1.4-0.9-3-1.7-4.6-2.3 c-2.3-0.9-4.8-1.3-7.3-1.1c-0.7,0-1.3,0.1-2,0.3C296.1,169.9,295.9,170,295.7,170.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M350.3,199.2c0.3,0.3,0.6,0.5,1,0.6l2.7,1.6l0.9,0.5c0.4,0.2,0.8,0.3,1.2,0.4c0.3,0,0.5,0,0.7-0.2 c0.2-0.2,0.4-0.4,0.4-0.7c0-0.5-0.2-1-0.5-1.4c-1-1.6-2-3.2-3.1-5.1l-0.4,0.4c2.1,1.6,4.7,2.3,7.3,2.2c0.3,0,0.7-0.1,1-0.2 c0.4-0.1,0.7-0.4,0.8-0.7c0.1-0.4,0.1-0.8-0.2-1.1c-0.2-0.2-0.4-0.5-0.6-0.7c-1.4-1.4-2.6-2.9-3.7-4.6c-0.9-1.6-1.7-3.2-2.3-4.9 c0,0.5,0.2,1,0.3,1.4c0.4,1.3,1,2.5,1.6,3.7c1,1.8,2.2,3.4,3.6,4.8c0.4,0.4,0.8,0.8,0.6,1.1s-0.7,0.5-1.3,0.5 c-2.5,0.1-4.9-0.6-6.9-2.1l-1.3-0.9l0.9,1.3l3.2,5c0.2,0.3,0.4,0.6,0.5,1c0,0.3-0.3,0.5-0.5,0.5c0,0,0,0-0.1,0 c-0.7-0.1-1.3-0.4-1.9-0.8l-2.8-1.4C351.1,199.5,350.7,199.3,350.3,199.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M318.6,227.9c-0.4-1.7-2-2.8-3.7-2.7c-1.2,0.2-2.3,0.9-2.9,2.1c-0.5,1.1-0.6,2.4-0.2,3.6l0.1,0.3 c1.2,1.3,3,1.7,4.6,1C318.1,231.3,318.9,229.6,318.6,227.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M309.9,231.1c0-0.4,2.8-0.3,4.9-2.6s1.9-5.3,2.3-5.3c0.2,0,0.5,0.7,0.5,1.9c-0.1,1.6-0.7,3.2-1.8,4.4 c-1,1.2-2.5,1.9-4.1,2C310.5,231.6,309.9,231.3,309.9,231.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M278.5,380.4l1.3,7.6l-1.2,4.1c0,0-12.6,16-16.6,27.8s-4.3,42.8-4.3,42.8l143.2-0.1c0,0-5-46.1-23-60.6v-3.3 l4.5-6.6c0,0,1.5-5.1-5-4.3C374.7,388.1,278.5,380.4,278.5,380.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M378.6,397.6h-1l-2.9-0.1c-2.5-0.1-6.2-0.1-10.7-0.1s-9.9,0.1-15.9,0.2s-12.5,0.2-19.4,0.1 c-6.5-0.1-13-0.5-19.4-1.2c-5.3-0.6-10.5-1.6-15.6-2.9c-3.5-0.9-6.9-1.9-10.2-3.2c-1.2-0.4-2.1-0.9-2.7-1.1l-0.7-0.3 c-0.2-0.1-0.2-0.1-0.2-0.1l0.2,0.1l0.7,0.3c0.6,0.2,1.5,0.6,2.7,1c3.4,1.2,6.8,2.2,10.2,3c5.1,1.2,10.3,2.1,15.6,2.7 c5.9,0.7,12.5,1.1,19.4,1.2s13.4,0,19.4-0.1s11.4-0.2,15.9-0.1s8.2,0.1,10.7,0.2c1.3,0,2.2,0.1,2.9,0.2l0.8,0.1 C378.6,397.5,378.6,397.6,378.6,397.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M378.6,404.2c-0.1,0-0.2,0-0.2,0h-0.8l-2.9-0.1c-2.5-0.1-6.2-0.1-10.7-0.1s-9.9,0.1-15.9,0.2 s-12.5,0.2-19.4,0.1s-13.5-0.5-19.4-1.2c-5.3-0.6-10.5-1.6-15.6-2.9c-3.5-0.9-6.9-1.9-10.2-3.2c-1.2-0.4-2.1-0.8-2.7-1.1l-0.7-0.3 c-0.2-0.1-0.2-0.1-0.2-0.1l0.2,0.1l0.7,0.3c0.6,0.2,1.5,0.6,2.7,1c3.4,1.2,6.8,2.2,10.2,3c5.1,1.2,10.3,2.1,15.6,2.7 c5.9,0.7,12.5,1.1,19.4,1.2s13.4,0,19.4-0.1s11.4-0.2,15.9-0.1s8.2,0.1,10.7,0.2c1.3,0,2.2,0.1,2.9,0.2l0.8,0.1 C378.6,404.2,378.6,404.2,378.6,404.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M284.6,412c0.1-0.7,0.3-1.4,0.6-2c0.6-1.6,1.4-3.2,2.3-4.6c0.9-1.5,1.9-2.8,3.1-4.1c0.5-0.5,1-1,1.6-1.4 c0.1,0.1-2.2,2.4-4.3,5.8S284.8,412,284.6,412z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M289.7,421.2c-0.1-0.3-0.1-0.6,0-0.8c0-0.8,0.1-1.5,0.1-2.3c0.3-2.5,0.8-5,1.6-7.4c0.8-2.4,1.7-4.7,2.8-7 c0.4-1,0.9-1.9,1.5-2.7c-0.3,1-0.8,1.9-1.2,2.9c-1,2.3-1.9,4.6-2.6,7c-0.8,2.4-1.3,4.8-1.8,7.3C289.9,420,289.8,421.2,289.7,421.2z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M293.1,385c0.1,0.5,0.2,0.9,0.3,1.4c0.2,1.1,0.5,2.2,0.9,3.3c0.9,2.5,2.1,4.4,2,4.5c-1.1-1.2-2-2.7-2.4-4.3 c-0.4-1.1-0.7-2.2-0.8-3.4C293,386,293,385.5,293.1,385z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M297.4,388c0.5,1,0.9,2.2,1.1,3.3c0.4,1.1,0.6,2.3,0.6,3.4C298.1,392.6,297.6,390.3,297.4,388z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M322.9,387c0.3,3.4,0.3,6.8,0,10.2C322.6,393.8,322.6,390.4,322.9,387z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M326.1,389.6c0.7,2.6,0.7,5.3-0.2,7.8c-0.1,0,0.1-1.8,0.2-3.9S326,389.6,326.1,389.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M334.8,413.2c-0.4-1.4-0.6-2.9-0.8-4.4c-0.4-1.4-0.6-2.9-0.8-4.4c0.7,1.3,1.1,2.8,1.3,4.3 C334.8,410.2,334.9,411.7,334.8,413.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M249,313.5c-0.3-0.9,10.2-31,16.5-35.6s34.4-11.1,34.4-11.1s11.9,11.7,27.8,9.3s28.1-13.6,28.1-13.6 s30.1,3.9,35.2,7.6s19,36.6,19,36.6l-24.5,20.4l-2.2,18.5c0,0,1.1,38.5-1.4,42.5S279.1,382,279.1,382s-5.1-0.9-1.1-10 s6.8-15.2,6.8-15.2s-7.1-7.9-8.2-21.9s-3.9-15.5-3.9-15.5L249,313.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M383.1,344.9c-0.1,0,1.4-12.6,3.4-28s3.7-28,3.9-28s-1.4,12.6-3.4,28S383.3,344.9,383.1,344.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M275.7,324.6c-0.1,0-2-4.5-4.2-10.1s-3.8-10.2-3.7-10.2s2,4.5,4.2,10S275.9,324.6,275.7,324.6z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M307.5,340.7c-0.5-2.6-1.5-5.1-3.2-7.1c-2.4-2.7-6.1-3.8-9.6-3.8c-3.5,0.2-7.1,0.9-10.4,2l-6.4,10 c0.4,1.2,1.4,2.2,2.6,2.6c1.2,0.4,2.5,0.6,3.7,0.7c6.6,0.5,13.2,0.8,19.8,0.8c0.9,0.1,1.7-0.1,2.5-0.5 C308,344.5,307.9,342.4,307.5,340.7z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M263.8,294.8c0.2,0.3,0.4,0.7,0.5,1c0.3,0.7,0.7,1.7,1.2,2.9c1,2.5,2.3,6,3.7,9.8s2.5,7.4,3.2,10 c0.4,1.3,0.7,2.3,0.9,3.1c0.1,0.4,0.2,0.8,0.2,1.1c-0.2-0.3-0.3-0.7-0.4-1.1l-1-3c-0.8-2.5-2-6.1-3.4-9.9s-2.6-7.4-3.5-9.9 c-0.4-1.2-0.8-2.2-1.1-3C264,295.6,263.9,295.2,263.8,294.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M263.8,298l11.2,40.9c0.4,1.4,1.7,2.3,3.1,2.3h24.3c1.7,0.1,3.1-1.3,3.2-3c0-0.2,0-0.5-0.1-0.7l-9.8-40.9 c-0.4-1.4-1.7-2.4-3.1-2.4h-25.7c-1.7-0.1-3.1,1.3-3.2,3C263.7,297.5,263.7,297.7,263.8,298z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M272.2,305.6c0,0-2.9-1.4-5.2,0s-6,7.5-6,7.5l-2.3,9.7l1.6,13.2l0.6,6.1l14.8,1.7v-4.9l17-12.7 c0,0,6-1.6,5.5-3.4s-1.2-3-2.9-2.7s-19.8,5-19.8,5s-2.9,0.6-2.8-0.2s8.5-4.7,9.9-5.6s7.8-2.4,7-5.3c-0.3-1.9-2.2-3.2-4.1-2.8 c-0.3,0-0.5,0.1-0.8,0.2l-14.7,5.3l-2.4,0.6l0.3-3.8l2.6-3.5c1,0.3,2-0.2,2.3-1.2c0,0,0,0,0-0.1C273.2,307.7,273,306.5,272.2,305.6 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M270.3,316.7c-1.1,0.6-2.3,1.1-3.6,1.5c-1.2,0.5-2.5,0.8-3.8,1c1.1-0.6,2.3-1.1,3.6-1.5 C267.7,317.2,269,316.8,270.3,316.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M273.6,325.5c-1.1,0.6-2.2,1-3.4,1.3c-1.1,0.4-2.3,0.7-3.5,0.8C268.9,326.5,271.2,325.8,273.6,325.5 L273.6,325.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M291.8,326.4c-0.3,0.2-0.5,0.4-0.9,0.5c-0.6,0.3-1.4,0.7-2.5,1.2c-2.7,1.2-5.5,2.3-8.3,3.3 c-2.8,1-5.7,1.7-8.6,2.4c-1.1,0.2-2,0.4-2.7,0.5c-0.3,0.1-0.7,0.1-1,0.1c1.2-0.4,2.4-0.7,3.6-1c2.2-0.6,5.2-1.4,8.5-2.5 s6.2-2.2,8.4-3.1C289.4,327.2,290.6,326.8,291.8,326.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M264.9,333.5c0,0.1-1-0.4-1.3-1.5s0.2-2.1,0.3-2s-0.1,0.9,0.2,1.8S265,333.4,264.9,333.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M262,325.8c0,0.1-0.3,0-0.6-0.2c-0.9-0.6-1.2-1.7-0.9-2.7c0.1-0.4,0.3-0.5,0.4-0.5s-0.2,0.9,0.1,1.9 S262,325.7,262,325.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M260.3,316.4c0,0.2,0,0.3,0,0.5c-0.1,0.4-0.2,0.8-0.3,1.4c-0.2,1.3-0.6,3-1,5.1v-0.1 c0.6,4.6,1.5,11.4,2.5,18.9v0.1v0.1c-0.2,0.5-0.4,1-0.6,1.6c-2.2,6.2-3.2,12.7-3,19.2c0.1,2,0.2,4,0.5,5.9c0.1,0.6,0.2,1.2,0.2,1.6 c0,0.2,0.1,0.4,0,0.6c-0.1-0.2-0.1-0.4-0.1-0.5c-0.1-0.4-0.2-0.9-0.3-1.6c-0.3-2-0.6-3.9-0.6-5.9c-0.3-6.6,0.7-13.2,2.9-19.4 c0.2-0.5,0.4-1.1,0.6-1.6v0.1c-1-7.5-1.8-14.3-2.3-18.9l0,0l1.2-5c0.1-0.5,0.2-1,0.3-1.3C260.2,316.8,260.3,316.6,260.3,316.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M278.2,337.5c-1,1-2.1,1.8-3.4,2.3c-1.2,0.7-2.5,1.1-3.9,1.2c0-0.1,1.7-0.7,3.7-1.7S278.1,337.3,278.2,337.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M372,358.2c0,0,3.9,1,4.2,3.5s-2.7,46-2.7,46h3.7c0,0,1.5-43.1,1.4-46.1s-1.5-3.3-2.1-3.5 C375.1,357.7,373.5,357.7,372,358.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M370,358.2l17.7,0.7l-3.5-21.4l1.2-10.4l23.5-19.6c0,0,8.2,47.6,9,53.1c0.9,6.6-0.4,15.4-3.6,18.5 c-2.7,2.7-22.4,0-30,0c-4.2,0-14.2,0.1-14.2,0.1l-3.5-16.4L370,358.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M414.3,358.9c-0.1,0.1-1.3-1-3.6-2c-3-1.4-6.3-1.9-9.5-1.7c-1.8,0.1-3.6,0.5-5.2,1.1c-1.5,0.6-2.9,1.3-4.1,1.8 c-0.9,0.4-1.9,0.7-2.9,0.8c-0.4,0.1-0.7,0.1-1.1,0c1.3-0.2,2.7-0.5,3.9-1.1c1.2-0.5,2.5-1.3,4.1-1.9c1.7-0.7,3.5-1.1,5.4-1.2 c3.4-0.2,6.7,0.4,9.7,1.9c0.9,0.4,1.8,1,2.6,1.6C413.7,358.4,414,358.6,414.3,358.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M351.8,397.6c-0.6,0.8-8.1,65.3-8.1,65.3l77.7-0.3l-12.3-64.8L351.8,397.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M364.7,462.7c-0.1,0-1-14.5-1.8-32.4s-1.4-32.3-1.3-32.3s0.9,14.5,1.8,32.4S364.8,462.7,364.7,462.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M333,359.2c2.1-0.3,4.3-0.8,6.4-1.4c1-0.5,1.9-1,2.8-1.6l10-0.8l17.9,2.7c0,0,3,2.2,2.6,8.8 c-0.4,4.4-1.3,8.8-2.8,13c0,0-8,6.5-10.1,6.9s-14.3-0.3-15.5-1.2c-0.7-0.5-1.3-1.2-1.8-2c-1.3-0.7-2.1-2.2-1.8-3.6 c0,0-4.2-5.4-4.7-7.7s0.1-2.8,0.1-2.8s-1.2-3.1-0.3-4.2c1-1.1,2.6-1.2,3.7-0.2c0,0,0.1,0,0.1,0.1c1,1.1,6.9,0.3,6.9,0.3l5.3-3.5 c-2.7,0.7-5.5,1.2-8.2,1.5C340.6,363.4,332,365.3,333,359.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M353.7,372c0,0.1-1.1,0.3-2.8,0.9c-0.9,0.3-1.9,0.7-3,1c-1.3,0.4-2.6,0.7-3.9,0.7c-1.4,0-2.7-0.3-3.9-1 c-0.9-0.6-1.7-1.3-2.4-2.2c-0.5-0.6-0.9-1.1-1.2-1.8c-0.3-0.4-0.4-0.7-0.4-0.7s0.7,0.9,1.9,2.2c0.7,0.8,1.5,1.5,2.4,2 c1.1,0.6,2.3,0.9,3.6,0.9c2.7-0.1,5-1.1,6.8-1.6C351.7,372.2,352.7,372,353.7,372z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M357.3,367.2c0,0,0.2,0.1,0.4,0.5c0.2,0.5,0.2,1,0,1.5c-0.2,0.5-0.5,0.9-0.9,1.2c-0.3,0.2-0.6,0.2-0.6,0.1 s0.7-0.5,1-1.5S357.2,367.3,357.3,367.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M356.9,379.1c-0.8,0.2-1.7,0.4-2.5,0.5c-1.6,0.2-3.7,0.5-6.1,0.7c-1.1,0.2-2.3,0.2-3.4,0.3 c-0.9,0-1.9-0.1-2.8-0.4c-0.9-0.2-1.6-0.8-2.1-1.5c0.7,0.5,1.4,0.9,2.2,1.2c0.9,0.2,1.8,0.4,2.7,0.3c1,0,2.1-0.2,3.3-0.3 c2.4-0.3,4.5-0.5,6.1-0.6C355.2,379,356.1,379,356.9,379.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M361.5,374.8c0.1,0,0.2,0.2,0.4,0.6c0.2,0.6,0.2,1.2,0,1.8c-0.2,0.6-0.5,1.1-0.9,1.5c-0.4,0.3-0.6,0.4-0.7,0.3 s0.8-0.8,1.1-2C361.6,376.4,361.6,375.6,361.5,374.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M358.7,384.5c-0.8,0.2-1.6,0.3-2.4,0.4c-3.9,0.3-7.8,0.1-11.6-0.7c-0.8-0.1-1.6-0.3-2.3-0.6 c0.8,0,1.6,0.1,2.4,0.3c1.5,0.2,3.5,0.5,5.7,0.6s4.3,0.1,5.8,0.1C357.1,384.4,357.9,384.4,358.7,384.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M375.6,357.9c0,0,3.5,2.6,4.1,4.2s7.6,35.5,7.6,35.5h3c0,0-7.1-36.7-8.9-38.2c-0.6-0.5-1.3-1-2-1.3 C378.3,357.5,376.9,357.4,375.6,357.9L375.6,357.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M307.3,364.5c-1,0.1-2,0.1-3,0c-4.8-0.4-9.3-2-13.4-4.5c-0.9-0.5-1.7-1.1-2.4-1.8c0-0.1,1,0.6,2.6,1.5 c2,1.2,4.2,2.1,6.4,2.9c2.2,0.7,4.5,1.3,6.9,1.6C306.2,364.4,307.3,364.5,307.3,364.5z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M324.8,364c-1.8-0.2-3.7-0.1-5.5,0.2c-9.4,1-19,1-27.6-3.8c1.2,2.6,3.3,4.6,5.9,5.8c3,1,6.1,1.5,9.2,1.5 c7.5,0.3,15.1,0,22.5-1C328.4,365.2,326.7,364.2,324.8,364z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M296.3,268c0-7.4-6-13.4-13.4-13.4l0,0h-81.5c-7.4,0.2-13.2,6.4-13,13.7c0.2,7.1,5.9,12.8,13,13h48.7 c4.6,4.4,12.4,10.4,12.4,10.4v-10.8l21.4,0.4C291.2,281.1,296.3,275,296.3,268z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M296.3,268c0,0,0,0.2,0,0.7c0,0.7-0.1,1.4-0.2,2.1c-0.2,1.2-0.6,2.3-1.1,3.3c-0.7,1.4-1.7,2.8-2.8,3.9 c-1.5,1.4-3.3,2.4-5.2,2.9c-0.5,0.1-1.1,0.3-1.6,0.4c-0.6,0.1-1.2,0.1-1.8,0.1l-3.7-0.1l-17.3-0.3l0.2-0.2c0,3.4,0,7,0,10.8v0.4 l-0.3-0.3c-4-3.1-8.3-6.5-12.4-10.4l0.2,0.1h-29.5h-16.1c-1.4,0-2.7,0-4.1,0c-5.6-0.4-10.3-4.2-12-9.6c-0.3-1.1-0.5-2.2-0.6-3.4 c-0.1-1.1,0-2.3,0.2-3.4c0.2-1.1,0.6-2.2,1.1-3.2c1.9-4.1,5.8-6.9,10.2-7.6c1.1-0.1,2.1-0.2,3.2-0.2H224l41.6,0.1h16 c1.1,0,2.3,0,3.4,0.2c1,0.2,2.1,0.5,3.1,0.9c1.7,0.7,3.3,1.8,4.5,3.1c1,1.1,1.9,2.3,2.5,3.6c0.2,0.5,0.5,1.1,0.6,1.6 c0.1,0.5,0.3,1,0.4,1.4c0.1,0.7,0.2,1.3,0.2,2C296.3,267.7,296.3,267.9,296.3,268c0-0.1,0-0.3-0.1-0.7c0-0.7-0.1-1.3-0.3-2 c-0.1-0.4-0.2-0.9-0.4-1.4c-0.2-0.6-0.4-1.1-0.7-1.6c-0.6-1.3-1.5-2.5-2.5-3.6c-1.3-1.3-2.8-2.3-4.5-3c-1-0.4-2-0.7-3-0.8 c-1.1-0.2-2.2-0.2-3.4-0.2h-16H224h-21.4c-1,0-2.1,0-3.1,0.2c-5.4,0.9-9.8,5-10.9,10.3c-0.4,2.2-0.3,4.4,0.3,6.5 c0.3,1.1,0.8,2.1,1.4,3c2.2,3.6,6,5.9,10.2,6.2c1.3,0.1,2.8,0,4.1,0h16.1h29.5h0.1l0.1,0.1c4.1,3.9,8.4,7.3,12.3,10.4l-0.3,0.2 c0-3.8,0-7.4,0-10.8v-0.2h0.2l17.3,0.4c2.5,0,4.9,0.3,7-0.4c1.9-0.4,3.7-1.4,5.2-2.6c1.2-1.1,2.1-2.4,2.8-3.8 c0.8-1.7,1.3-3.5,1.4-5.4C296.3,268.2,296.3,268,296.3,268z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Icon--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M278.7,272.2c-0.2,0-0.4,0-0.6,0c-2.7-0.4-4.6-2.8-4.2-5.5c0.4-2.7,2.8-4.6,5.5-4.2c2.7,0.4,4.6,2.8,4.2,5.5 l0,0C283.2,270.4,281.2,272.2,278.7,272.2z M278.7,263.3c-2,0-3.6,1.5-3.9,3.4c-0.3,2.1,1.2,4.1,3.4,4.4c2.1,0.3,4.1-1.2,4.4-3.4 l0,0c0.3-2.1-1.2-4.1-3.4-4.4c0,0,0,0,0,0C279.1,263.3,278.9,263.3,278.7,263.3L278.7,263.3z M283.1,267.8L283.1,267.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M285.4,273.3c-0.1,0-0.2,0-0.3-0.1l-3.2-2.7c-0.2-0.2-0.2-0.5-0.1-0.7c0.2-0.2,0.5-0.2,0.7-0.1l3.2,2.7 c0.2,0.2,0.2,0.5,0.1,0.7C285.7,273.3,285.5,273.3,285.4,273.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg03LocationSearch);
export default __webpack_public_path__ + "static/media/03_Location_search.0336a8b4147fb3967f96bc153d0c3312.svg";
export { ForwardRef as ReactComponent };